module.exports = __webpack_public_path__ + "img/Z85-X18-中_04.f2cb56f7.jpg";